import Vue from 'vue';
import Vuex from 'vuex';
import Api from '@/api';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    canShop: false, // 是否可以下单
    isVad: false, // 是VAD账号
    isSub: false, // 是USB账号
    isAdmin: false // 是否是管理员
  },
  mutations: {
    setUser (state, data) {
      state.user = data;
      state.isVad = !!(data.partnerType && data.partnerType.toLowerCase() === 'vad');
      state.isSub = !!(data.partnerType && data.partnerType.toLowerCase() === 'sub');
      // 只有vad和sub才能下单
      state.canShop = state.isVad || state.isSub;
      state.isAdmin = !state.isVad && !state.isSub && data.admin;
    }
  },
  actions: {
    getUser ({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.user !== null && state.user !== '') {
          resolve(state.user);
          return;
        }
        Api.getUserInfoName().then((res) => {
          let json = res.data;
          if (json.status === '200') {
            console.log('获取用户当前登录的角色', json.data);
            // commit('setUser', json.data);
            resolve(json.data);
          } else {
            reject(new Error('未登录'));
          }
        }).catch((e) => {
        // console.log(e);
          reject(new Error('未登录'));
        });
      });
    }
  }
});
